class mainPage {
	constructor({page}) {
		this.page = page;
	}

}

new mainPage({
	page: document.querySelector('.js-sft-page')
})